import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";
import { safeJson } from "../utils/safeJson";

export async function fetchProcess() {

  const url = new URL("/process", API_BASE_URL);

  const response = await fetch(url.toString());
  const data = await safeJson(response);
  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao buscar processos"));
  }

  return data;
}
